import { Injectable, signal } from '@angular/core';
import { UserEnterpriseInfoViewModel } from '@/app/proxy/proxies';

@Injectable({
  providedIn: 'root',
})
export class SustainabilityDashboardService {
  readonly selectedEnterprise = signal<UserEnterpriseInfoViewModel | null>(null);
  readonly selectedContractId = signal<string | null>(null);
  readonly selectedContractName = signal('');
  readonly selectedSubcontractId = signal<string | null>(null);
  readonly selectedSubcontractName = signal('');

  selectEnterprise(enterprise: UserEnterpriseInfoViewModel | null): void {
    this.selectedEnterprise.set(enterprise);
  }

  selectContract(contractId: string | null, contractName?: string | null): void {
    this.selectedContractId.set(contractId);
    this.selectedContractName.set(contractName ?? '');
  }

  selectSubcontract(subcontractId: string | null, subcontractName?: string | null): void {
    this.selectedSubcontractId.set(subcontractId);
    this.selectedSubcontractName.set(subcontractName ?? '');
  }
}
